import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { Text, View } from 'react-native';
export default function FavoriteNoResult() {
    return (_jsx(View, { className: "grow items-center justify-center gap-4", children: _jsx(Text, { className: "pb-[120px] font-pretendard-medium text-[14px] leading-[20px] text-gray-50", children: "\uC800\uC7A5\uD55C \uC7A5\uC18C\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4." }) }));
}
